// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605061034/js/" + chunkId + "." + {"44":"939be37c","225":"d6ed06df","481":"8a4007a8","486":"ab53e8a5","770":"ffe8f02b"}[chunkId] + ".0.7796269001838965.chunk.js";
};